import { StepsDataType, TryAgainType } from '@lib/types/steps'
import { defineMessage } from '@lingui/macro'

export const SUMMER_CAMP_FORM_ID = 'summer-camp-form'

export const SUMMER_CAMP_IMAGE_PATH = '/images/summer-camp/'

export type CourseDataType = {
  styles?: {
    backgroundColor: string
    border: string
  }
  name: string
  description: string
  features?: any
  grade: string
  price: string
  discountPrice: string
  originalPrice: string
  paymentPage: string
  isRoboticsCourse: boolean
  borderColor: string
  backgroundColor: string
  campaignQuery: string
  headingColor?: string
}

export const COURSE_DATA: CourseDataType[] = [
  {
    borderColor: '#EB4962',
    backgroundColor: '#FFF5F7',
    name: 'Scratch Programming',
    description:
      'In this Scratch Bootcamp, you will learn how to make projects on Scratch and understand concepts like loops, conditionals, and functions',
    features: [
      {
        title: 'What will you learn?',
        text:
          'In this Scratch Summer Camp, students will learn how to make projects on Scratch along with learning concepts like loops, conditionals and Functions',
      },
      {
        title: 'Coding Concepts Covered',
        text:
          'Drag and drop function, block coding, commands, sequencing, algorithm, events, time and direction sense, logic building along with , hands-on experience on Scratch Projects.',
      },
      { title: 'Achievements', text: 'Scratch Programer Certificate' },
    ],
    grade: '1 - 8',
    price: '6999',
    discountPrice: '6000',
    originalPrice: '9600',
    paymentPage: 'https://pages.razorpay.com/pl_H3wNYwUeUMKggi/view',
    isRoboticsCourse: false,
    campaignQuery: 'Scratch Programming Course',
  },
  {
    borderColor: '#E515A7',
    backgroundColor: '#FFF5FF',
    name: 'App Development',
    description:
      'In this Application Development Summer Camp, you will learn about UI (User Interface) and the operating systems used for mobile phones. You will know how to multiscreen apps',
    features: [
      {
        title: 'What will you learn?',
        text:
          'In this Application Development Summer Camp, you will learn about User Interface and also about the operating systems which are used for mobile phones. You will learn how to build Multiscreen Apps and share with your friends.',
      },
      {
        title: 'Coding Concepts Covered',
        text:
          'Understanding Interfaces, building User Interfaces, Game App Development, Sharable application',
      },
      { title: 'Achievements', text: 'App Developer Certificate' },
    ],
    grade: '1 - 10',
    price: '6999',
    discountPrice: '6000',
    originalPrice: '9600',
    paymentPage: 'https://pages.razorpay.com/pl_H3wIXGbLPXrfQJ/view',
    isRoboticsCourse: false,
    campaignQuery: 'App Development Course',
  },
  {
    borderColor: '#2792FC',
    backgroundColor: '#F5FAFF',
    name: 'Game Development',
    description:
      'In this Game Development Summer Camp, you will build exciting games in Game Lab and design the UI and UX for the game from ideation to execution',
    features: [
      {
        title: 'What will you learn?',
        text:
          'In this Game Development Summer Camp, you will build exciting games in Game Lab and will be able to share the games with friends.',
      },
      {
        title: 'Coding Concepts Covered',
        text:
          'Functions, controls and variables, colour codes and mouse movements, declaring multiple variables, conditional statements and coordinates.',
      },
      { title: 'Achievements', text: 'Game Developer Certificate' },
    ],
    grade: '1 - 8',
    price: '6999',
    discountPrice: '6000',
    originalPrice: '9600',
    paymentPage: 'https://pages.razorpay.com/pl_H3wLF9I44qelCb/view',
    isRoboticsCourse: false,
    campaignQuery: 'Game Development Course',
  },
  {
    borderColor: '#EAD40C',
    backgroundColor: '#FFFEF5',
    name: 'Website Development',
    description:
      'In this Web Development Summer Camp, you will be learning programming languages such as HTML and CSS used for building websites. They will learn to make creative web pages using CSS (Cascading Style Sheets) and how to link multiple web pages of a website',
    features: [
      {
        title: 'What will you learn?',
        text:
          'In this Web Development Summer Camp, you will be learning programming languages such as HTML and CSS used for building websites. You will learn how to make creative web pages using Cascading Style Sheets and how to link multiple web pages to make a website of your own.',
      },
      {
        title: 'Coding Concepts Covered',
        text: 'HTM, CSS, creating web pages, static Website',
      },
      { title: 'Achievements', text: 'Website Developer Certificate' },
    ],
    grade: '4 - 12',
    price: '6999',
    discountPrice: '6000',
    originalPrice: '9600',
    paymentPage: 'https://pages.razorpay.com/pl_H3s285g6PSDZM9/view',
    isRoboticsCourse: false,
    campaignQuery: 'Web Development Course',
  },
  {
    borderColor: '#00EDBE',
    backgroundColor: '#F5FFFD',
    name: 'Python Programming',
    description:
      'In this Python Development Summer Camp, you will learn writing syntax in Python language. You will be learning how to use loops and conditionals statements in python using different data types. You will also be working with turtles to create various projects',
    features: [
      {
        title: 'What will you learn?',
        text:
          'In this Python Development Summer Camp, ypu will learn writing syntax in Python. You will be learning how to use loops and conditionals statements in python using different data types. You will also be working with turtles to create various projects.',
      },
      {
        title: 'Coding Concepts Covered',
        text:
          'Animation and Basic concept of Python, Loops, Conditional Statements, Data types, Turtle is Python',
      },
      { title: 'Achievements', text: 'Python Developer Certificate' },
    ],
    grade: '4 - 12',
    price: '6999',
    discountPrice: '6000',
    originalPrice: '9600',
    paymentPage: 'https://pages.razorpay.com/pl_H3s6CiLT4SXBfS/view',
    isRoboticsCourse: false,
    campaignQuery: 'Python Programming Course',
  },
  {
    borderColor: '#2A6AFF',
    backgroundColor: '#F5F8FF',
    name: 'Robotics',
    description:
      'In this Robotics Summer Camp, you will learn about loops conditionals and functions in coding. You will also learn to apply it to hardware and learn to make your dancing robot and line follower robot',
    features: [
      {
        title: 'What will you learn?',
        text:
          'In this Robotics course, you will learn about loops conditionals and functions in coding. You will also learn to apply it on hardware and learn to make your own dancing robot and line follower robot.',
      },
      {
        title: 'Coding Concepts Covered',
        text:
          'Basic concepts of electricity , Sensors, Logic Gates, Complex coding Concepts , Autonomous Robotics',
      },
      { title: 'Achievements', text: 'Robotics Certificate' },
    ],
    grade: '4 - 12',
    price: '9999',
    discountPrice: '9000',
    originalPrice: '9600',
    paymentPage: 'https://pages.razorpay.com/pl_H3ru1dr1WiM1nN/view',
    isRoboticsCourse: true,
    campaignQuery: 'Robotics Course',
  },
]

export const GRADES_ONE_TO_EIGHT = [
  {
    title: 'Coding Certification Course',
    whatYouLearnDataArr: [
      'Learn coding fundamentals like loops, variables, and conditionals',
      'Develop apps, games, and websites on different platforms like Scratch, Thunkable, etc.',
    ],
    conceptCoveredDataArr: [
      'Scratch Programming',
      'Algorithms',
      'Javascript',
      'Sprite Lab',
      'App Lab',
      'Drag and Drop Function',
      'Block Coding',
      'Commands, Sequencing and Events',
      'Logic Building',
      'Time and Direction Sense',
    ],
    whatYouGetDataArr: [
      'Coding Certificate from STEM.org',
      'Scholarships for top five performers',
      'Lifetime community access',
      '60+ Activities',
      '20 Quizzes',
    ],
    price: '14,400',
    discountPrice: '6000',
    originalPrice: '16,000',
    isRoboticsCourse: false,
    styles: {
      backgroundColor: '#F3FFF8',
      border: '',
    },
    campaignQuery: 'Coding Certification Course',
    headingColor: '#4AAF50',
  },
]

export const GRADES_NINE_TO_TWELVE = [
  {
    title: 'Python Programming',
    whatYouLearnDataArr: [
      'Learn text-based coding, principles of coding concepts, etc. ',
      'Loops and conditionals.',
      'Working with turtles to create various projects.',
    ],
    conceptCoveredDataArr: [
      'Python Basics',
      'Loops and Functions',
      'Advance Python',
      'Introduction to Programming',
      'Variables',
      'Data Types and Structures',
      'Object Oriented Programming',
    ],
    whatYouGetDataArr: [
      'Python Developer Certificate',
      'Scholarships for top five performers',
      'Lifetime community access',
      '60+ Activities',
      '20 Quizzes',
    ],
    price: '14,400',
    discountPrice: '6000',
    originalPrice: '16,000',
    isRoboticsCourse: false,
    styles: {
      backgroundColor: '#F7F2FE',
      border: '',
    },
    campaignQuery: 'Python Programming',
    headingColor: '#7E36D9',
  },
  {
    title: 'Website Development',
    whatYouLearnDataArr: [
      'Learn programming languages - HTML and CSS.',
      'Learn to make creative web pages - Cascading Style Sheets.',
      'Learn to link multiple web pages to create your own website.',
    ],
    conceptCoveredDataArr: [
      'HTML',
      'Website Building Principles',
      'CSS',
      'Grid Creation With Bootstrap',
      'JavaScript',
      'NodeJS',
    ],
    whatYouGetDataArr: [
      'Web Developer Certificate',
      'Scholarships for top five performers',
      'Lifetime community access',
      '60+ Activities',
      '20 Quizzes',
    ],
    price: '14,400',
    discountPrice: '6000',
    originalPrice: '16,000',
    isRoboticsCourse: false,
    styles: {
      backgroundColor: '#E9F2FF',
      border: '',
    },
    campaignQuery: 'Website Development',
    headingColor: '#2F80ED',
  },
]

export const GRADES = [
  {
    title: defineMessage({ message: 'Grade 1-8' }),
    content: GRADES_ONE_TO_EIGHT,
  },
  {
    title: defineMessage({ message: 'Grade 9-12' }),
    content: GRADES_NINE_TO_TWELVE,
  },
]

export const SUMMER_CAMP_CHECKOUT_ENUM = {
  loading: 0,
  enterDetails: 1,
  selectCourse: 2,
  makePayment: 3,
  paymentConfirmation: 4,
  paymentSuccess: 5,
}

export const SUMMER_CAMP_QUERY = {
  paymentStatus: 'payment-status',
}

export const SUMMER_CAMP_PROGRESS_STEPS_DATA: StepsDataType[] = [
  {
    title: 'Enter your details',
    number: SUMMER_CAMP_CHECKOUT_ENUM.enterDetails,
  },
  {
    title: 'Select your course',
    number: SUMMER_CAMP_CHECKOUT_ENUM.selectCourse,
  },
  { title: 'Payment', number: SUMMER_CAMP_CHECKOUT_ENUM.makePayment },
  {
    title: 'Confirmation email',
    number: SUMMER_CAMP_CHECKOUT_ENUM.paymentConfirmation,
  },
]

export const NEXT_STEP_ROUTE = '/summer-camp/checkout/'

export const SUMMER_CAMP_TRY_AGAIN_DATA: TryAgainType = {
  link: NEXT_STEP_ROUTE,
  resetStep: SUMMER_CAMP_CHECKOUT_ENUM.selectCourse,
}

export const COURSES_QUERY = {
  coding101: 'Coding 101',
  robotics: 'Robotics',
  webDevelopment: 'Web Development',
  pythonProgramming: 'Python Programming',
  appDevelopment: 'App Development',
  gameDevelopment: 'Game Development',
  scratchProgramming: 'Scratch Programming',
}

export const SUMMER_CAMP_PROCESS_DATA = [
  { number: 1, step: 'Each course is 20 sessions.' },
  {
    number: 2,
    step:
      'Click on Book Free Lesson and submit your details. Our academic counsellors will contact you shortly to schedule your sessions.',
  },
  {
    number: 3,
    step: 'The 20 sessions need to be completed in consecutive sessions.',
  },
  { number: 4, step: 'Sessions will be of 45 minutes duration.' },
  { number: 5, step: 'Offer valid till June 30, 2022.' },
  {
    number: 6,
    step:
      'Customisation of Curriculum will not be available for Summer Coding Camp sessions.',
  },
]
export const RAMADAN_CAMP_PROCESS_DATA = [
  { number: 1, step: 'Each course is 20 sessions.' },
  {
    number: 2,
    step:
      'Click on Book Free Lesson and submit your details. Our academic counsellors will contact you shortly to schedule your sessions.',
  },
  {
    number: 3,
    step: 'The 20 sessions need to be completed in consecutive sessions.',
  },
  { number: 4, step: 'Sessions will be of 45 minutes duration.' },
  { number: 5, step: 'Offer valid till June 30, 2022.' },
  {
    number: 6,
    step:
      'Customisation of Curriculum will not be available for Ramadan Coding Camp sessions.',
  },
]
export const DEFAULT_CTA = 'Book Free Lesson'
